import { render, staticRenderFns } from "./Call.vue?vue&type=template&id=577ab3a2&"
import script from "./Call.vue?vue&type=script&lang=ts&"
export * from "./Call.vue?vue&type=script&lang=ts&"
import style0 from "./Call.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports